import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Pages
import Forside from './pages/Forside';
import OmOs from './pages/OmOs';
import Ydelser from './pages/Ydelser';
import YdelseDetail from './pages/YdelseDetail';
import Kontakt from './pages/Kontakt';
import { NotFoundPage, ForbiddenPage } from './pages/ErrorPages';

export default function App() {
  return (
    <div className="flex flex-col min-h-screen bg-[#F4F1EA] text-[#1C1E1D] antialiased selection:bg-[#163A2B] selection:text-white">
      <ScrollToTop />
      
      {/* Navigation Header */}
      <Navbar />

      {/* Main Content Area */}
      <main className="flex-grow">
        <Routes>
          {/* Home Page */}
          <Route path="/" element={<Forside />} />
          
          {/* About Page */}
          <Route path="/om-larsen-kristensen" element={<OmOs />} />
          
          {/* Services Overview Page */}
          <Route path="/ydelser" element={<Ydelser />} />
          
          {/* Sub-service: Ny indkørsel under Belægning */}
          <Route path="/ydelser/belaegning/ny-indkoersel" element={<YdelseDetail slugOverride="ny-indkoersel" />} />
          
          {/* Sub-service: Ny terrasse under Belægning */}
          <Route path="/ydelser/belaegning/ny-terrasse" element={<YdelseDetail slugOverride="ny-terrasse" />} />

          {/* Sub-service: Støttemur under Belægning */}
          <Route path="/ydelser/belaegning/stoettemur" element={<YdelseDetail slugOverride="stoettemur" />} />
          
          {/* Sub-service: Haveanlæg under Anlægsarbejde */}
          <Route path="/ydelser/anlaegsarbejde/haveanlaeg" element={<YdelseDetail slugOverride="haveanlaeg" />} />
          
          {/* Service Detail Pages (Belægning, Entreprenør, Støbearbejde, Betonarbejde, Totalløsninger, Anlægsarbejde) */}
          <Route path="/ydelser/:slug" element={<YdelseDetail />} />
          
          {/* Contact Page */}
          <Route path="/kontakt" element={<Kontakt />} />
          
          {/* Error Pages */}
          <Route path="/403" element={<ForbiddenPage />} />
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />

    </div>
  );
}
